import { BasePage } from '@/components/ui/base-page'

export function ESGPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add ESGPage specific content here */}
    </BasePage>
  )
}